import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#050505] text-neutral-100 flex flex-col overflow-x-hidden max-w-full">
      <Header />
      <main className="flex-1 relative overflow-x-hidden max-w-full w-full">{children}</main>
      <Footer />
    </div>
  );
}
